<template>
  <ms-popup
    v-model="show"
    :title="$t('i18nDataManagement.DataManagement.HistoryDataManagement')"
    size="xl"
    :is-loading="isLoading"
    @update:model-value="updateShow"
  >
    <template #content>
      <div class="history-data-management-popup">
        <!-- Bộ lọc khoảng thời gian -->
        <div class="filter-container flex-between mb-2">
          <div class="datetime-filter flex-row">
            <div class="from-date mr-2">
              <ms-date-picker
                v-model="filter.from_date"
                :placeholder="$t('i18nDataManagement.HistoryDataManagementPopup.FromDate')"
                :label="$t('i18nDataManagement.HistoryDataManagementPopup.FromDate')"
                position="bottom"
              />
            </div>
            <div class="to-date">
              <ms-date-picker
                v-model="filter.to_date"
                :placeholder="$t('i18nDataManagement.HistoryDataManagementPopup.ToDate')"
                :label="$t('i18nDataManagement.HistoryDataManagementPopup.ToDate')"
                position="bottom"
              />
            </div>
          </div>
          <div class="apply-filter">
            <ms-button
              class="btn-filter"
              :text="$t('i18nDataManagement.HistoryDataManagementPopup.Apply')"
              @click="fetchData"
            />
          </div>
        </div>

        <!-- Bảng dữ liệu lịch sử -->
        <div class="data-container">
          <ms-grid
            :columns="columns"
            :data="historyData"
            :is-loading="isLoading"
            :has-no-data="historyData.length === 0"
            :total-records="totalRecords"
            :page-number="filter.page_number"
            :page-size="filter.page_size"
            @page-change="onPageChange"
          />
        </div>
      </div>
    </template>
  </ms-popup>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue';
import databaseHistoryAPI from '@/apis/system/databaseHistoryAPI';
import moment from 'moment';

export default defineComponent({
  name: 'HistoryDataManagementPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const show = ref(props.value);
    const isLoading = ref(false);
    const historyData = ref([]);
    const totalRecords = ref(0);

    // Định nghĩa bộ lọc
    const filter = reactive({
      from_date: new Date(new Date().setDate(new Date().getDate() - 30)), // Mặc định lấy 30 ngày gần nhất
      to_date: new Date(),
      user_id: null,
      action_type: null,
      page_size: 20,
      page_number: 1
    });

    // Định nghĩa cột cho bảng
    const columns = [
      {
        field: 'user_name',
        headerName: 'Tên người dùng',
        width: 200
      },
      {
        field: 'formatted_time',
        headerName: 'Thời gian',
        width: 180
      },
      {
        field: 'action_name',
        headerName: 'Hành động',
        width: 180
      },
      {
        field: 'detail',
        headerName: 'Mô tả chi tiết',
        width: 400
      }
    ];

    // Phương thức lấy dữ liệu từ API
    const fetchData = async () => {
      isLoading.value = true;
      try {
        const result = await databaseHistoryAPI.getDatabaseHistory(filter);
        if (result && result.Data) {
          historyData.value = result.Data;
          totalRecords.value = result.TotalRecord || 0;
        } else {
          historyData.value = [];
          totalRecords.value = 0;
        }
      } catch (error) {
        console.error('Error fetching database history:', error);
        historyData.value = [];
        totalRecords.value = 0;
      } finally {
        isLoading.value = false;
      }
    };

    // Xử lý khi người dùng chuyển trang
    const onPageChange = (pageInfo) => {
      filter.page_number = pageInfo.page_number || 1;
      filter.page_size = pageInfo.page_size || 20;
      fetchData();
    };

    // Watch show value và emit event khi có thay đổi
    const updateShow = (value) => {
      show.value = value;
      emit('update:modelValue', value);
    };

    onMounted(() => {
      fetchData();
    });

    return {
      show,
      isLoading,
      filter,
      columns,
      historyData,
      totalRecords,
      fetchData,
      onPageChange,
      updateShow
    };
  }
});
</script>

<style lang="scss" scoped>
.history-data-management-popup {
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .filter-container {
    padding: 10px 0;
  }

  .data-container {
    flex: 1;
    overflow: auto;
  }
}
</style>
